import React from "react";
import { Eye } from "lucide-react";
import { computeStickiness } from "../../utils/viewersDeskHelpers";

const AudienceStickinessCard = ({ pulse, compact = false }) => {
  const s = computeStickiness(pulse);

  return (
    <section
      className={`aud-card${compact ? " aud-card-compact" : ""}`}
      aria-label="Attention stickiness"
    >
      <span className="aud-kicker">Stickiness</span>
      {!compact ? (
        <p className="aud-caption">How hard your profile pulls each viewer back</p>
      ) : null}

      {s.totalViews === 0 ? (
        <p className="aud-hero-verdict aud-hero-verdict-compact">No views yet.</p>
      ) : compact ? (
        <>
          <div className="aud-stickiness-compact">
            <strong className="tabular-nums aud-up">
              {s.ratioLabel != null ? `${s.ratioLabel}×` : "—"}
            </strong>
            <span>views / viewer</span>
          </div>
          {s.repeatPct != null ? (
            <div className="aud-meter aud-meter-compact">
              <div className="aud-meter-head">
                <span>Repeat</span>
                <strong className="tabular-nums">{s.repeatPct}%</strong>
              </div>
              <div className="aud-meter-track" aria-hidden>
                <span
                  className={`aud-meter-fill${s.repeatPct < 20 ? " aud-meter-fill-low" : ""}`}
                  style={{ width: `${Math.max(s.repeatPct, 2)}%` }}
                />
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <>
          <div className="aud-hero-row">
            <strong className="aud-hero-value tabular-nums">
              {s.ratioLabel != null ? `${s.ratioLabel}×` : "—"}
            </strong>
            <span className="aud-hero-unit">
              views per viewer · {s.totalViews.toLocaleString()} views from{" "}
              {s.uniqueViewers.toLocaleString()} people
            </span>
          </div>

          {s.repeatPct != null ? (
            <div className="aud-meter">
              <div className="aud-meter-head">
                <span>
                  Repeat viewers · {s.repeatViewers.toLocaleString()} of{" "}
                  {s.uniqueViewers.toLocaleString()}
                </span>
                <strong className="tabular-nums">{s.repeatPct}%</strong>
              </div>
              <div
                className="aud-meter-track"
                role="meter"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={s.repeatPct}
                aria-label="Share of viewers who came back"
              >
                <span
                  className={`aud-meter-fill${s.repeatPct < 20 ? " aud-meter-fill-low" : ""}`}
                  style={{ width: `${Math.max(s.repeatPct, 2)}%` }}
                />
              </div>
            </div>
          ) : null}

          <span className="aud-recency">
            <Eye size={11} />
            {s.ratioLabel != null ? `${s.ratioLabel}× avg attention` : "Building stickiness read"}
          </span>
        </>
      )}
    </section>
  );
};

export default AudienceStickinessCard;
